import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    setSelectedCategory(url);
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section id="categories" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Explore Superbuy Sheet Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Choose a category below to discover organized product collections, compare options, 
            and find exactly what you are looking for on the main platform.
          </p>
        </div>

        <div className="flex flex-col items-center gap-8 mb-10">
          <div className="w-full max-w-md relative">
            <label htmlFor="category-select" className="block text-sm font-medium text-foreground-700 mb-2 text-center">
              Quick Category Selector
            </label>
            <div className="relative">
              <select
                id="category-select"
                value={selectedCategory}
                onChange={handleDropdownChange}
                className="w-full appearance-none px-5 py-3.5 pr-12 bg-background-50 border border-background-300/70 rounded-xl text-sm text-foreground-800 cursor-pointer focus:outline-none focus:border-primary-400 transition-colors"
              >
                <option value="">— Select a Category —</option>
                {categories.map((cat) => (
                  <option key={cat.name} value={cat.url}>
                    {cat.name}
                  </option>
                ))}
              </select>
              <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-down-s-line text-foreground-500"></i>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-3 flex-wrap justify-center">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Superbuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-2.5 bg-accent-500 text-background-50 rounded-full text-sm font-semibold hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-2 p-4 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <span className="text-xs font-medium text-foreground-700 text-center leading-tight group-hover:text-foreground-900 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}